import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout")(
    {
        component: () => <UserLayout />,
        loader: ({ context: { t } }) => ({
            breadcrumb: t("pages.tool.structure.lead.title"),
        }),
    }
);

function UserLayout() {
    return <Outlet />;
}
